export const PERMIT_FORM_TYPES = [
  "hot_work",
  "confined_space",
  "working_at_height",
  "electrical_isolation",
  "excavation",
  "general_work",
] as const;

export const TRAINING_FORM_TYPES = [
  "site_induction",
  "toolbox_talk_record",
  "training_competency_record",
] as const;

export const RECORDS_FORM_TYPES = [
  "accident_incident_report",
  "daily_site_report",
  "risk_assessment",
  "method_statement",
  "coshh_assessment",
  "first_aid_record",
  "emergency_drill_log",
  "non_conformance_report",
  "site_safety_inspection",
  "plant_equipment_check",
  "visitor_log",
] as const;
